'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _discountCoupon = require('../../redux/modules/discountCoupon');
var _DiscountCouponContainer = require('./DiscountCouponContainer.scss');var _DiscountCouponContainer2 = _interopRequireDefault(_DiscountCouponContainer);
var _couponsConfig = require('./couponsConfig');
var _paymentCalculation = require('../../helpers/paymentCalculation');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

DiscountCouponContainer = function (_Component) {_inherits(DiscountCouponContainer, _Component);function DiscountCouponContainer() {var _temp, _this, _ret;_classCallCheck(this, DiscountCouponContainer);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      showInput: false,
      couponCode: null }, _this.






    handleChange = function (evt) {
      var value = (evt.target.value || '').trim();
      _this.props.updateCoupon(value);
      _this.setState({ couponCode: value });
    }, _this.

    sendCode = function (evt) {
      evt.preventDefault();
      if (_this.state.couponCode) {
        _this.props.checkDiscountCode({
          code: _this.state.couponCode,
          isAgent: _this.props.inLanding ? true : _this.props.isAgent,
          type: 'coupon' });

      }
    }, _this.

    showInput = function () {return _this.setState({ showInput: true });}, _this.

    renderCouponButton = function () {return !_this.state.showInput &&
      _react2.default.createElement('div', { className: _DiscountCouponContainer2.default.couponButton },
        _react2.default.createElement('span', null, _this.props.translate('haveCoupon'), ',\xA0'),
        _react2.default.createElement('span', { className: _DiscountCouponContainer2.default.actionButton, onClick: _this.showInput }, _this.props.translate('clickHere')));}, _this.



    renderLoadingIndicator = function () {return (
        _react2.default.createElement('i', { className: 'icon icon-om-spinner om-pulse' }));}, _this.


    renderSendButton = function () {return (
        _react2.default.createElement('button', { onClick: _this.sendCode }, _this.props.translate('send')));}, _this.


    renderErrorMessage = function () {return (0, _get2.default)(_this.props, 'discountCoupon.error') &&
      _react2.default.createElement('span', { className: _DiscountCouponContainer2.default.errorMessage }, _this.props.translate('errorMessage'));}, _this.


    renderCouponInput = function () {return _this.state.showInput && !(0, _get2.default)(_this.props, 'discountCoupon.data.type') &&
      _react2.default.createElement('div', { className: _DiscountCouponContainer2.default.couponInput },
        _react2.default.createElement('div', { className: _DiscountCouponContainer2.default.label }, _this.props.translate('enterCode')),
        _react2.default.createElement('div', { className: _DiscountCouponContainer2.default.input },
          _react2.default.createElement('input', { onChange: _this.handleChange, type: 'text', className: 'form-control', placeholder: _this.props.translate('codePlaceholder') }),
          _this.renderErrorMessage()),

        (0, _get2.default)(_this.props, 'discountCoupon.loading') ? _this.renderLoadingIndicator() : _this.renderSendButton());}, _this.



    renderCouponBenefit = function () {
      var type = (0, _get2.default)(_this.props, 'discountCoupon.data.type');var
      inLanding = _this.props.inLanding;

      if (!type) {
        return null;
      }

      var coupon = (0, _get2.default)(_couponsConfig.discountCouponsTypes, ['' + type], {});
      var discount = inLanding ? '10% - 20' : (0, _paymentCalculation.getDiscountValue)(coupon.value, _this.props.selectedPackage);
      var title = _this.props.translate(coupon.type).replace(/%s/g, discount);

      return (
        _react2.default.createElement('div', { className: _DiscountCouponContainer2.default.couponBenefit },
          _react2.default.createElement('span', null, _this.props.translate('benefit'), ':\xA0'),
          _react2.default.createElement('span', null, title),
          _react2.default.createElement('span', null, '\xA0\xA0'),
          _react2.default.createElement('span', { className: _DiscountCouponContainer2.default.removeButton, onClick: _this.props.deleteCoupon },
            _this.props.translate('remove'))));



    }, _temp), _possibleConstructorReturn(_this, _ret);}DiscountCouponContainer.prototype.componentWillUnmount = function componentWillUnmount() {this.props.deleteCoupon();};DiscountCouponContainer.prototype.

  render = function render() {var _cx;
    return (
      _react2.default.createElement('div', {
          className: (0, _classnames2.default)((_cx = {}, _cx[
          _DiscountCouponContainer2.default.inLanding] = this.props.inLanding, _cx[
          _DiscountCouponContainer2.default.contactUsRealtor] = this.props.contactUsRealtor, _cx)) },


        this.renderCouponButton(),
        this.renderCouponInput(),
        this.renderCouponBenefit()));


  };return DiscountCouponContainer;}(_react.Component);


DiscountCouponContainer.propTypes = {
  inLanding: _propTypes2.default.bool,
  contactUsRealtor: _propTypes2.default.bool,
  locale: _propTypes2.default.string.isRequired,
  translate: _propTypes2.default.func,
  rootTranslate: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  isAgent: _propTypes2.default.bool,
  discountCoupon: _propTypes2.default.object,
  selectedPackage: _propTypes2.default.object,
  checkDiscountCode: _propTypes2.default.func,
  deleteCoupon: _propTypes2.default.func,
  updateCoupon: _propTypes2.default.func };


var mapStateToProps = function mapStateToProps(state) {return {
    locale: state.lang.locale,
    rootTranslate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    translate: (0, _reduxPagan.getLang)(state.lang, 'static', 'discountCoupon'),
    isMobile: state.windowDimentions.isMobile,
    isAgent: (0, _get2.default)(state, 'userAuthentication.data.is_agent'),
    discountCoupon: state.discountCoupon,
    selectedPackage: state.payments.selectedPackage };};exports.default =


(0, _reactRedux.connect)(mapStateToProps, {
  checkDiscountCode: _discountCoupon.checkDiscountCode,
  deleteCoupon: _discountCoupon.deleteCoupon })(
DiscountCouponContainer);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/DiscountCouponContainer/DiscountCouponContainer.js
// module id = 2936
// module chunks = 0